import type { ChartData } from "chart.js";
import { Chart } from "primereact/chart";
import type { RequestError } from "../../../../../api-requests/statistics";
import type { Statistics } from "../../../../../api/infrastructure/statistics.formatter";
import { checkIsRequestError } from "../../../../../helpers/check-schema-field-type";
import Spinner from "../../../utils/Spinner/Spinner";

import "./ChartPart.scss";

export default function ChartPart({
  statistics,
  chartData,
}: {
  statistics: Statistics | RequestError;
  chartData: ChartData | undefined;
}) {
  const chartOptions = {
    cutout: "75%",
    rotation: 60,
    aspectRatio: 0.5,
    responsive: false,
    plugins: {
      tooltip: {
        enabled: false,
        intersect: false,
      },
      legend: {
        position: "bottom",
        fullSize: true,
        align: "start",
      },
    },
  };
  if (checkIsRequestError(statistics)) {
    return (
      <div className="ChartPart Card StatisticsLoadFailed warn">
        {statistics.error ? statistics.error : "Le chargement des statistiques a échoué"}
      </div>
    );
  }
  if (!statistics.diagramData) {
    return <div className="ChartPart Card" />;
  }
  if (!chartData) return <Spinner />;
  return (
    <div className="ChartPart Card ">
      <span className="ChartPart-title">Diagramme</span>
      {/* TODO: handle large legend */}
      {statistics.diagramData.size === 0 && <div>Aucune donnée disponible</div>}
      <Chart
        type="doughnut"
        className="flex justify-content-center"
        height="400px"
        // className="w-full md:w-24rem"
        data={chartData}
        options={chartOptions}
      />
    </div>
  );
}
